import { useMemo } from 'react';
import { useExtensionUnitsList } from '../../../../hooks/extensionUnit/useExtensionUnitsList.js';
import ExtensionUnitTable from '../../../../components/tables/unitsLevels/ExtensionUnitTable.jsx';
import SearchBar from '../../../../components/utils/SearchBar.jsx';
import Pagination from '../../../../components/utils/Pagination.jsx';
import ErrorModal from '../../../../components/modales/ErrorModal.jsx';

export default function ListExtensionUnits() {
    // Traer listas
    const {
        extensionUnits,
        searchTerm,
        setSearchTerm,
        currentPage,
        setCurrentPage,
        itemsPerPage,
        error,
        setError,
        sortField,
        sortOrder,
        handleSort
    } = useExtensionUnitsList();

    // FILTRO POR BÚSQUEDA
    const filteredExtensionUnits = useMemo(() => {
        const search = searchTerm.toLowerCase();

        return extensionUnits.filter(extensionUnit => {
            return (
                (extensionUnit.name || '').toLowerCase().includes(search) ||
                (extensionUnit.shortname || '').toLowerCase().includes(search)
            );
        });
    }, [extensionUnits, searchTerm]);

    // PAGINACIÓN
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentExtensionUnits = filteredExtensionUnits.slice(indexOfFirstItem, indexOfLastItem);

    return (
        <>
            <div className='container-fluid mt-6'>
                <h1 className='text-center mt-5 mb-5'>Medidas de extensión</h1>
                <SearchBar 
                    searchTerm={searchTerm} 
                    handleSearchChange={e => {
                        setSearchTerm(e.target.value);
                        setCurrentPage(1);
                    }}
                />
                <ExtensionUnitTable
                    extensionUnits={currentExtensionUnits}
                    currentPage={currentPage}
                    itemsPerPage={itemsPerPage}
                    handleSort={handleSort}
                    sortField={sortField}
                    sortOrder={sortOrder}
                />
                <Pagination
                    itemsPerPage={itemsPerPage}
                    totalItems={filteredExtensionUnits.length}
                    currentPage={currentPage}
                    paginate={setCurrentPage}
                />
                <ErrorModal show={!!error} message={error} onClose={() => setError('')} />
            </div>
        </>
    );
}